import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { TipoServicoService } from '../services/tipo-servico.service';

@Component({
	selector: 'app-tipo-servico-edit',
	templateUrl: './tipo-servico-edit.component.html',
	styleUrls: ['./tipo-servico-edit.component.css'],
	animations: [loadingFade]
})
export class TipoServicoEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public tipo_servico_id = null;

	public formTipoServico: FormGroup;

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private tipoServicoSvc: TipoServicoService,
				private location: Location,
				private router: Router,) { }

	ngOnInit() {
		this.criaForm();

		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {
				this.tipo_servico_id = params.id;
				this.tipoServicoSvc.getTipoServico(params.id).then((data: any) => {
					this.preencheForm({
						tipo_servico_id: data.tipo_servico_id,
						tipo_servico_nome: data.tipo_servico_nome
					});

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formTipoServico = this.fb.group({
			tipo_servico_id: null,
			tipo_servico_nome: ['', Validators.required]
		});
	}

	preencheForm(dados) {
		this.formTipoServico.setValue(dados);
	}

	enviaTipoServico() {
		if (this.formTipoServico.valid) {
			this.submitting = true;

			let toSend = this.formTipoServico.value;

			if (this.tipo_servico_id === null) { // criar
				this.tipoServicoSvc.criaTipoServico(toSend).then((data) => {
					console.log('resp', data);
					this.router.navigate(['home/tiposervico']);
				}).catch(err => {
					console.log(err);
				});
			}
			else { // editar
				this.tipoServicoSvc.editaTipoServico(toSend).then((data) => {
					console.log('resp', data);
					this.router.navigate(['home/tiposervico']);
				}).catch(err => {
					console.log(err);
				});
			}
		}
	}

	invalid(nome) {
		let input = this.formTipoServico.get(nome);
		return input.touched && input.invalid;
	}

	voltar() {
		this.location.back();
	}
}
